import { AbstractControl, FormControl } from '@angular/forms';
import { IFormBuilder } from '../IFormBuilder';
import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';

export type CompanyControls = { [key: string]: AbstractControl } & {
  companyName: FormControl;
  siret: FormControl;
  vatNumber: FormControl;
  companyLegalStatus: FormControl;
};

interface ICompanyFormBuilder<T> extends IFormBuilder<T> {
  init(): ICompanyFormBuilder<T>;

  build(): IGenericBaryFormGroup<T>;
}

export class CompanyFormBuilder implements ICompanyFormBuilder<CompanyControls> {
  private formName = 'companyForm';
  private controls!: CompanyControls;

  constructor(private bcf: BaryFormFactoryService) {}

  init(): CompanyFormBuilder {
    this.controls = this.bcf.makeCompanyControls();
    return this;
  }

  build(): IGenericBaryFormGroup<CompanyControls> {
    return new GenericBaryFormGroup(this.formName, this.controls);
  }
}
